<template>
  <ButtonSquare
    :title="$t('general__view__satellite')"
    :imgSource="require('@/assets/icon-satellite.svg')"
    size="large"
    :activeState="isSatelliteActive ? 'active' : 'inactive'"
    @clicked="onClick"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { mapState, mapMutations } from 'vuex'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_IS_SATELLITE_ACTIVE } from '@/store/mutation-types'

export default {
  name: 'SatelliteButton',
  components: {
    ButtonSquare
  },
  computed: {
    ...mapState(MAPVIEW_PREFIX, {
      isSatelliteActive: (state) => state.isSatelliteActive
    })
  },
  methods: {
    onClick() {
      this.setIsSatelliteActive({ value: !this.isSatelliteActive })
    },
    ...mapMutations(MAPVIEW_PREFIX, {
      setIsSatelliteActive: SET_IS_SATELLITE_ACTIVE
    })
  }
}
</script>

<style lang="scss" scoped></style>
